import { actionType } from "..";
import { ALERT_OPEN, ALERT_CLOSE } from "../action-types/alertActionType";

export interface AlertType {
    open: boolean,
    message?: string,
    action?: string,
    url?:string,
}


const initialState = {
    open: false,
} as AlertType;

const alertReducer = (state = initialState, action: actionType) => {
    switch (action.type) {
        case ALERT_OPEN:
        case ALERT_CLOSE:
            return Object.assign({}, action.payload);
        default:
            return state;
    }
}

export default alertReducer;